import { Box, IconButton } from '@material-ui/core';
import { MenuSharp } from '@material-ui/icons';
import Logo from './Logo';
import { useLanguage } from '../contexts/language';
import FontSizeSelector from './FontSizeSelector';

const NavbarIconMenu = ({ setShowControlsMenu }) => {
  const { content } = useLanguage();
  return (
    <>
      <Box position="absolute" top={0} left={0} textAlign="left">
        <FontSizeSelector />
      </Box>
      <Box position="absolute" top={0} right={0} textAlign="right">
        <IconButton
          onClick={() => setShowControlsMenu(true)}
          aria-label={content('aria_open_controls_menu')}
          title={content('aria_open_controls_menu')}
        >
          <MenuSharp style={{ fontSize: '1.5rem' }} />
        </IconButton>
      </Box>
      <Box mt="4vh" mb="2vh" textAlign="center" py="0.75rem">
        <Logo />
      </Box>
    </>
  );
};

export default NavbarIconMenu;
